var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v("Add New User")]),
              _c(
                "gg-card-text",
                [
                  _c("create-user-form", {
                    on: {
                      "user-created": _vm.reloadUsers
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-md-3",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [_vm._v(" Manage Users ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "font-weight-regular",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            attrs: {
                              outlined: "",
                              "append-icon": "mdi-magnify",
                              placeholder: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.searchUser,
                              callback: function callback($$v) {
                                _vm.searchUser = $$v
                              },
                              expression: "searchUser"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c("users-table", {
                    attrs: {
                      search: _vm.searchUser,
                      loading: _vm.loadingUsers
                    },
                    on: {
                      "table-action-completed": _vm.reloadUsers
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }